module.exports = __webpack_public_path__ + "js/5.0a5a9de9.worker.js"